import { empApi } from "./client";

// Danh sách đợt mở bán -> { items, pagination }
export const getSalesOpeningEventListApi = (params) =>
  empApi.get("/saleOpeningEvent/app", params);

// Chi tiết đợt mở bán
export const getSalesOpeningEventByIdApi = (id) =>
  empApi.get(`/saleOpeningEvent/app/${id}`);
